"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styles_1 = require("../../../styles");
const label_1 = __importDefault(require("../../typography/label"));
const styled_1 = __importDefault(require("../../../styles/styled"));
const layout_1 = require("../../layout");
const icons_1 = require("../../icons");
const Checkbox = props => {
    const { checked, onChange, label, borderColor, small, disabled } = props;
    const id = `checkbox_${label}`;
    return ((0, jsx_runtime_1.jsxs)(CheckboxContainer, Object.assign({ "data-testid": props['data-testid'], alignItems: "center", justifyContent: "center", onClick: disabled ? undefined : onChange, checked: checked, disabled: disabled }, { children: [(0, jsx_runtime_1.jsx)(label_1.default, Object.assign({ htmlFor: id, screenReaderOnly: true }, { children: label })), (0, jsx_runtime_1.jsx)("input", { id: id, style: styles_1.screenReaderOnly, type: "checkbox", tabIndex: 0, checked: checked, onChange: disabled ? undefined : onChange, disabled: disabled }), (0, jsx_runtime_1.jsx)(CheckedIndicator, Object.assign({ disabled: disabled, small: small, borderColor: borderColor, checked: !!checked }, { children: checked && (0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: "CheckmarkIcon", color: "white" }) }))] })));
};
exports.Checkbox = Checkbox;
const CheckboxContainer = (0, styled_1.default)(layout_1.Flex)({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
}, ({ theme, checked, disabled }) => ({
    cursor: disabled ? 'not-allowed' : 'pointer',
    ':hover': {
        backgroundColor: !disabled ? `${theme.colors.blue50}15` : undefined,
    },
    ':active': {
        backgroundColor: disabled
            ? undefined
            : checked
                ? `${theme.colors.blue50}25`
                : `${theme.colors.blue50}20`,
    },
}));
const CheckedIndicator = (0, styled_1.default)(layout_1.Box)({
    transition: 'background-color 0.2s',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}, ({ checked, theme, small, borderColor, disabled }) => ({
    backgroundColor: checked && disabled
        ? theme.colors.grey20
        : checked
            ? theme.colors.blue50
            : borderColor
                ? borderColor
                : undefined,
    height: small ? '20px' : '24px',
    width: small ? '20px' : '24px',
    border: `2px solid ${disabled ? theme.colors.grey20 : checked ? theme.colors.blue50 : theme.colors.grey50}`,
    ':hover': {
        border: `2px solid ${disabled ? theme.colors.grey20 : checked ? theme.colors.blue60 : theme.colors.grey50}`,
        backgroundColor: checked && disabled
            ? theme.colors.grey20
            : checked
                ? theme.colors.blue60
                : undefined,
    },
    ':active': {
        backgroundColor: checked ? theme.colors.blue70 : undefined,
        border: `2px solid ${disabled ? theme.colors.grey20 : checked ? theme.colors.blue70 : theme.colors.grey50}`,
    },
}));
//# sourceMappingURL=checkbox.js.map